// フロア離脱後に Vuetify が overflow を再制御したらスクロール修正を解除するための
// MutationObserver + setTimeout セット。setTimeout の handle を closure に保持し、
// cancel 時に確実にクリアすることで連続ルート遷移時のレースを防ぐ。

const OBSERVE_DELAY_MS = 2000
const OBSERVE_OPTIONS = { attributes: true, attributeFilter: ['style', 'class'] }

export const createFloorFixScroll = () => {
  let observer = null
  let timeoutId = null

  const cancel = () => {
    if (observer) {
      observer.disconnect()
      observer = null
    }
    if (timeoutId !== null) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
  }

  const start = (target, onTrigger) => {
    cancel()
    observer = new MutationObserver(() => {
      onTrigger()
      cancel()
    })
    timeoutId = setTimeout(() => {
      if (observer) observer.observe(target, OBSERVE_OPTIONS)
      timeoutId = null
    }, OBSERVE_DELAY_MS)
  }

  return { start, cancel }
}
